import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpParams } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService extends BaseService {
  private settingsCache$: Observable<any> | null = null;
  private pagesCache$: Observable<any> | null = null;
  getDestination(parent_id: any = 1): Observable<any> {
    let paramsId = new HttpParams();
    if (parent_id) {
      paramsId = paramsId.set('parent_id', parent_id);
    }

    return this.HttpClient.get(`${this.baseUrl}/destinations`, {
      params: paramsId,
    });
  }
  getDestinationBySlug(slug: string): Observable<any> {
    return this.HttpClient.get(`${this.baseUrl}/destinations/${slug}`, {
      params: { includes: 'seo' },
    });
  }
  getCategories(): Observable<any> {
    return this.HttpClient.get(`${this.baseUrl}/categories`, {
      params: { page_limit: 100 },
    });
  }
  getTours(searchObj?: any, page: number = 1): Observable<any> {
    const params = {
      includes: 'destinations,categories,days,seo,options',
      ...searchObj,
      page: page,
    };

    return this.HttpClient.get(`${this.baseUrl}/tours`, { params: params });
  }

  getTourPagination(page: number): Observable<any> {
    return this.HttpClient.get(
      `${this.baseUrl}/tours?includes=destinations,categories,days&page=${page}`,
    );
  }

  getToursSlug(slug: any): Observable<any> {
    const includes = { includes: 'destinations,categories,days,seo' };
    return this.HttpClient.get(`${this.baseUrl}/tours?slug=${slug}`, {
      params: includes,
    });
  }

  getTourBySlug(slug: string): Observable<any> {
    return this.getToursSlug(slug);
  }

  // durations
  getDurations(): Observable<any> {
    return this.HttpClient.get(`${this.baseUrl}/durations`);
  }

  // testimonial
  getReviews(): Observable<any> {
    return this.HttpClient.get(`${this.baseUrl}/tour-reviews`);
  }

  getBlogs(slug?: string): Observable<any> {
    const url = slug
      ? `${this.baseUrl}/blogs/${slug}`
      : `${this.baseUrl}/blogs`;
    const params = slug ? { includes: 'seo' } : undefined;
    return this.HttpClient.get(url, { params });
  }

  getBlogBySlug(slug: string): Observable<any> {
    return this.getBlogs(slug);
  }

  postReviews(userReview: object): Observable<any> {
    return this.HttpClient.post(`${this.baseUrl}/tour-reviews`, userReview);
  }

  getFAQs(): Observable<any> {
    return this.HttpClient.get(`${this.baseUrl}/faqs`);
  }

  getCategoriesBlog(id?: number): Observable<any> {
    const url = id
      ? `${this.baseUrl}/blog-categories/${id}`
      : `${this.baseUrl}/blog-categories`;
    return this.HttpClient.get(url);
  }

  // wishlist
  toggleWishlist(tourId: any): Observable<any> {
    return this.HttpClient.put(`${this.baseUrl}/wishlist/${tourId}/toggle`, {});
  }

  getWishlist(): Observable<any> {
    return this.HttpClient.get(`${this.baseUrl}/wishlist`);
  }

  getPages(): Observable<any> {
    if (!this.pagesCache$) {
      this.pagesCache$ = this.HttpClient.get(`${this.baseUrl}/pages`, {
        params: { includes: 'seo' },
      }).pipe(shareReplay(1));
    }
    return this.pagesCache$;
  }

  clearPagesCache(): void {
    this.pagesCache$ = null;
  }

  // settings
  getSetting(): Observable<any> {
    if (!this.settingsCache$) {
      this.settingsCache$ = this.HttpClient.get(
        `${this.baseUrl}/settings`,
      ).pipe(shareReplay(1));
    }
    return this.settingsCache$;
  }
}
